import { createStore, combineReducers, compose, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { commonReducer } from "./reducers";
import { form12Reducer } from "./reducers/form12";
import { form11Reducer } from "./reducers/form11";
import { registrationReducer } from "./reducers/registration";
import { form26Reducer } from "./reducers/form26";
import { formCLUReducer } from "./reducers/formCLU";
import { form34Reducer } from "./reducers/form34";
import { formNOCReducer } from "./reducers/formNOC";
import { form16Reducer } from "./reducers/form16";
import { formMTReducer } from "./reducers/formMT";
import { nocReducer } from "./reducers/formLANDUSE";
import { checklistReducer } from "./reducers/ownerEMOChecklist";
import checklistReviewReducer from "./reducers/formPurchasableFar";
import schemeRateReducer from "./reducers/reducerMdms";
import applicationDataReducer from "./reducers/applicationDataReducer";
import remarksDialogReducer from "./reducers/remarksDialog";
import { checklistLTPReducer } from "./reducers/ltpChecklistForm";
import siteInspectionReportReducer from "./reducers/siteInspectionData";
import empInboxReducer from "./reducers/empInbox";

const getRootReducer = (defaultStore, moduleReducers) =>
  combineReducers({
    common: commonReducer(defaultStore),
    form12: form12Reducer(),
    form11: form11Reducer(),
    form26: form26Reducer(),
    formCLU: formCLUReducer(),
    formNOC: formNOCReducer(),
    form16: form16Reducer(),
    formMT: formMTReducer(),
    form34: form34Reducer(),
    formLandUse: nocReducer,
    registration: registrationReducer(),
    checkList: checklistReducer,
    purchasableFarChecklist: checklistReviewReducer,
    ltpChecklist: checklistLTPReducer,
    inspectionReportChecklist: siteInspectionReportReducer,
    approvedLandUseData: applicationDataReducer,
    remarksDialog: remarksDialogReducer,
    mdmsSchemes: schemeRateReducer,
    empInbox: empInboxReducer,
    ...moduleReducers,
  });

const middleware = [thunk];

const composeEnhancers =
  typeof window === "object" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({}) : compose;

const enhancer = composeEnhancers(
  applyMiddleware(...middleware)
  // other store enhancers if any
);

const getStore = (defaultStore, moduleReducers = {}) => {
  return createStore(getRootReducer(defaultStore, moduleReducers), enhancer);
};
export default getStore;
